import { EDIT_VENDOR_PRODUCT, RESET_EDIT_VENDOR_PRODUCT } from "../types";

const initialState = {
  isEditVendorProduct: false,
  editVendorProduct: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EDIT_VENDOR_PRODUCT:
      return {
        ...state,
        isEditVendorProduct: true,
        editVendorProduct: action.payload,
      };

    case RESET_EDIT_VENDOR_PRODUCT:
      return (state = initialState);

    default:
      return state;
  }
};
